export default __webpack_public_path__ + "static/media/showMore.154ebe86.svg";